import type { ReactNode } from 'react'
import type { LeadMessage } from '../services/leadsApi'

// Каким нашим аккаунтом шло сообщение. Юзернеймы аккаунтов меняются (после
// блокировок и т.п.), поэтому берём снимок на момент сообщения; у старых
// сообщений снимка нет - тогда показываем текущий юзернейм с пометкой.
export function messageAccountLabel(item: LeadMessage): { label: string; isCurrent: boolean } {
    const phone = item.account_phone ? `+${item.account_phone.replace(/^\+/, '')}` : ''
    const format = (username?: string | null) => {
        const clean = (username || '').replace(/^@/, '').trim()
        return clean ? `@${clean}` : phone || 'аккаунт не известен'
    }
    if (item.message_account_username !== null && item.message_account_username !== undefined) {
        return { label: format(item.message_account_username), isCurrent: false }
    }
    return { label: format(item.account_username), isCurrent: true }
}

export function messageAuthorTooltip(item: LeadMessage): ReactNode {
    const { label, isCurrent } = messageAccountLabel(item)
    const currentNote = isCurrent
        ? <div style={{ opacity: 0.7, fontSize: 12 }}>Текущий юзернейм аккаунта: прежний для этого сообщения не сохранялся</div>
        : null
    if (!item.outgoing) {
        return <div><div>Лид писал на {label}</div>{currentNote}</div>
    }
    return (
        <div>
            <div>Отправил: {item.operator_name || 'не указан (рассылка или сообщение с телефона)'}</div>
            <div>С аккаунта {label}</div>
            {currentNote}
        </div>
    )
}
